import { render, staticRenderFns } from "./CallLeftNavigation.vue?vue&type=template&id=bb8952ae&scoped=true&"
import script from "./CallLeftNavigation.vue?vue&type=script&lang=js&"
export * from "./CallLeftNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CallLeftNavigation.vue?vue&type=style&index=0&id=bb8952ae&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8952ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VList,VListGroup,VListItem,VListItemContent,VListItemTitle,VSheet})
